'use client';

import { useState } from 'react';
import { motion } from 'framer-motion';
import MissionBlock, { Mission } from './MissionBlock';

interface Props {
    initMissions: Mission[];
}

// 任務清單（client）：SSR 資料當初始值，領取成功後把該筆標記完成、移到最下面，並用 framer-motion 做位移動畫
const MissionSection = ({ initMissions }: Props) => {
    const [missions, setMissions] = useState(initMissions);

    // 領取成功：把該筆標記為已完成，並放到清單最後面
    const handleClaimed = (id: number) => {
        setMissions((prev) => {
            const claimedMission = prev.find((m) => m.id === id);
            if (!claimedMission) return prev;

            const rest = prev.filter((m) => m.id !== id);
            const notDone = rest.filter((m) => m.status !== 'done');
            const alreadyDone = rest.filter((m) => m.status === 'done');

            // 未完成的維持原順序在前，已完成的維持原順序在後，剛領取的這筆接在最後面
            return [...notDone, ...alreadyDone, { ...claimedMission, status: 'done' }];
        });
    };

    return (
        <div className="space-y-3">
            {missions.map((mission) => (
                <motion.div key={mission.id} layout transition={{ duration: 0.3 }}>
                    <MissionBlock mission={mission} onClaimed={handleClaimed} />
                </motion.div>
            ))}
        </div>
    );
};

export default MissionSection;
